module.exports = __webpack_public_path__ + "img/绿幕抠图--大图.7d4ee009.png";